import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
// Khai báo biên kế thừa từ đối tượng đã có
declare var $: any;
@Injectable({
  providedIn: 'root',
})
export class OnevnService {
  url = 'http://api.oliu.io/api/';
  apikey = '1ha4xd0ddf83dr348fs03dkd9dfdpq8r762';
  constructor(private http: HttpClient) {}
  public setHeader() {
    let headers = null;
    try {
      const token = localStorage.getItem('token');
      if (token !== '') {
        headers = new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        });
      } else {
        headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      }
    } catch (e) {
      headers = new Headers({ 'Content-Type': 'application/json' });
    }
    return headers;
  }
  // Phương thức get API
  public get(apiname: string, params: any) {
    const linknew =
      this.url + apiname + '?api=' + this.apikey + this.objToQuery(params);
    return this.http.get(
      linknew,
      new HttpErrorResponse({ headers: this.setHeader() })
    );
  }
  // Gửi và đọc dữ liệu từ API qua phương thức post
  public post(apiname: string, data: any = {}, params: any = {}) {
    console.log(params);
    const linknew =
      this.url + apiname + '?api=' + this.apikey + this.objToQuery(params);
    return this.http.post(
      linknew,
      JSON.stringify(data),
      new HttpErrorResponse({ headers: this.setHeader() })
    );
  }
  // Chuyển từ mảng object sang querystring
  objToQuery(obj) {
    let qrstr = Object.keys(obj)
      .reduce(function (a, k) {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
      }, [])
      .join('&');
    if (qrstr !== '') {
      qrstr = '&' + qrstr;
    }
    return qrstr;
  }
  //  Hàm di chuyển con trỏ theo phím enter và phím điều hướng
  //  cần có tabindex tại thẻ html
  moveFocus(event: any = null, index: number) {
    if (
      event.which === 9 ||
      event.keyCode == 9 ||
      event.which === 13 ||
      event.keyCode == 13
    ) {
      var indexNext = index + 1;
      $('[tabindex=' + indexNext + ']').focus();
    } else if (event.which === 38 || event.keyCode == 38) {
      if (index > 0) {
        var indexUndo = index - 1;
        $('[tabindex=' + indexUndo + ']').focus();
      }
    }
  }
}
